<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <logo />
        </b-link>

        <b-card-title class="mb-1 text-center">
          {{ t('Email Verification') }}
        </b-card-title>

        <b-card-text class="mb-2 text-center">
          {{ validationMessage }}
        </b-card-text>

        <page-loading v-if="isLoading" />
      </b-card>
    </div>
  </div>
</template>
<script>
import { BCard, BLink, BCardTitle, BCardText } from 'bootstrap-vue';
import Logo from '@core/layouts/components/Logo.vue';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us';
import { showSuccessMessage, showErrorMessage } from '@core/helpers/toast.helper';
import PageLoading from '@core/components/PageLoading.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    BCard,
    BCardTitle,
    BLink,
    Logo,
    BCardText,
    PageLoading
  },

  mixins: [togglePasswordVisibility, helper],

  setup() {
    const { t } = useI18nUtils();
    const validationMessage = t('The validation process is being performed...');
    const isLoading = false;

    return {
      t,
      validationMessage,
      isLoading
    };
  },

  mounted() {
    this.isLoading = true;
    this.loadItems();
  },

  methods: {
    loadItems() {
      const { token } = this.$route.query;
      if (!token) {
        this.validationMessage = this.$t('Invalid authentication link.');
        this.isLoading = false;
        return;
      }
      useService
        .verifyUser(token)
        .then(() => {
          this.validationMessage = this.$t('Authentication successful. You can log in.');
          showSuccessMessage(this.validationMessage);
          this.$router.push('/login');
        })
        .catch(() => {
          this.validationMessage = this.$t(
            'An error occurred during verification. Please try again.'
          );
          showErrorMessage(this.validationMessage);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
